var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#loading_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16 5.072a8 8 0 1 0-8 13.856 8 8 0 0 0 8-13.856ZM3.34 7C6.1 2.217 12.217.578 17 3.34 21.783 6.1 23.422 12.217 20.66 17 17.9 21.783 11.783 23.422 7 20.66 2.217 17.9.578 11.783 3.34 7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.305 2.086a10 10 0 0 1 8.354 7.326 1 1 0 0 1-1.931.517 8 8 0 1 0-5.657 9.798 1 1 0 1 1 .517 1.932 10 10 0 1 1-1.283-19.573Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "loading_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgLoading;